import React, { Component } from 'react';
import { Row, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';


class EmployeeManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            sheetData: []
        };
        this.headers = [
            { display: 'Name', accessors: ['firstName', 'lastName'] },
            { display: 'Employee #', accessors: ['employeeNumber'] },
            { display: 'Location', accessors: ['location'] },
            { display: 'Hire Date', accessors: ['hireDate'] },
            { display: 'Years', accessors: ['years'] },
            { display: 'Team', accessors: ['teamName'] },
            { display: 'Position / Role', accessors: ['positionRole'] },
            { display: 'Time Zone', accessors: ['timeZone'] },
            { display: 'Start Time', accessors: ['startTime'] },
            { display: 'End Time', accessors: ['endTime'] },
        ]
    }

    componentDidMount() {
        this.props.log('EmployeeManager.js/componentDidMount');
        this.onSubmit();
    }

    onSubmit = () => {
        this.props.log('EmployeeManager.js/onSubmit');
        fetch('/api/reports/EmployeeManagerReport', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: results.data
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.log('EmployeeManager.js/getCSVdata');
        let retArray = [[...this.headers].map(header => header.display)];
        this.state.data.forEach(row => {
            let rowArray = [];
            this.headers.forEach(field => {
                rowArray.push(field.accessors.map(accessor => {
                    let retVal = '';
                    switch (accessor) {
                        // case "years":
                        //     retVal = parseFloat(row[accessor])//.toFixed(2);
                        case "hireDate":
                            retVal = this.getDate(row[accessor]);
                            break;
                        case "startTime":
                        case "endTime":
                            retVal = this.getTime(row[accessor]);
                            break;
                        default:
                            retVal = row[accessor]
                    }
                    return retVal;
                }).join(' ').trim());
            })
            retArray.push(rowArray);
        })
        this.props.passData(retArray, "employee-manager-report");
    }

    getDate = (d) => {
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + String(d).substring(0, 4);
    }

    getTime = (isoTime) => {
        var hours = parseInt(new Date(isoTime).toISOString().substring(11, 13), 10),
            minutes = new Date(isoTime).toISOString().substring(14, 16),
            ampm = 'am';
        if (hours === 12) {
            ampm = 'pm';
        } else if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
            ampm = 'pm';
        }
        return hours + ':' + minutes + ' ' + ampm;
    }

    render() {
        this.props.info('EmployeeManager.js/render');
        return (
            <>
                {this.state.data.length > 0 ?
                    <>
                        <Row><Table>
                            <thead>
                                <tr>
                                    <th>Employee</th>
                                    <th>Employee #</th>
                                    <th>Location</th>
                                    <th>Hire Date</th>
                                    <th>Years</th>
                                    <th>Team</th>
                                    <th>Position / Role</th>
                                    <th>Time Zone</th>
                                    <th>Start Time</th>
                                    <th>End Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data.map(row => (
                                    <tr key={row.firstName + row.lastName}>
                                        <td>{row.firstName} {row.lastName}</td>
                                        <td>{row.employeeNumber}</td>
                                        <td>{row.location}</td>
                                        <td>{this.getDate(row.hireDate)}</td>
                                        <td>{Number(row.years).toFixed(2)}</td>
                                        <td>{row.teamName}</td>
                                        <td>{row.positionRole}</td>
                                        <td>{row.timeZone}</td>
                                        <td>{this.getTime(row.startTime)}</td>
                                        <td>{this.getTime(row.endTime)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table></Row>
                    </>
                    : <>No results</>}
            </>
        );

    }
}

export default EmployeeManager;
